import { CSSProperties } from '@material-ui/styles/withStyles';

import { UseStylesProps } from '../types';

const dirStyleGenerator = <T extends keyof CSSProperties>(key: T | '', value: any, defaultValue: any = undefined) => ({
	[`${key}${key === '' ? 'r' : 'R'}ight`]: ({ dir }: UseStylesProps) => dir === 'ltr' ? value : defaultValue,
	[`${key}${key === '' ? 'l' : 'L'}eft`]: ({ dir }: UseStylesProps) => dir === 'ltr' ? defaultValue : value,
});

export default dirStyleGenerator;